export const search = (state) => (query) => {
	if(!query) return []
	let oq = query
	let results = state.clients.filter(client => {
		query = query.toLowerCase()
		if(client.parent) return false
		let match = false
		if(!client.examen) {
			if(client.nombre.toLowerCase().includes(query) || client.rfc.toLowerCase().includes(query))  {
				match = true
			}
		} else {
			debugger
			if(client.codigo == oq )  {
				match = true
			}
		}
		return match
	})

	return results.map(client => {
		client = JSON.stringify(client)
		client = JSON.parse(client)

		let hijos = JSON.stringify(state.clients.filter(c => c.parent == client.id))

		client.hijos = JSON.parse(hijos)

		return client
	})
}

export const  getById = (state) => (id) => {
	
	let client = state.clients.find(c => c.id == id)
	
	let hijos = JSON.stringify(state.clients.filter(c => c.parent == client.id))

	let datos = {
		datos: client,
		hijos: JSON.parse(hijos),
		estado: 'En curso - iniciado',
	}
	return datos
}
